module.exports = __webpack_public_path__ + "static/media/img02.f2cdbdfa.jpeg";